<template functional>
  <v-alert
    :dismissible="props.dismissible"
    transition="scale-transition"
    :type="props.type"
		:outline="props.outline"
    :value="props.message"
    @click="$emit('dismissed')"
  >{{ props.message }}</v-alert>
</template>

<script>
export default {
	name: 'Alert',
	props: {
		message: {
			default: 'An unexpected error has occured!'
		},
		type: {
			default: 'error'
		},
		outline: {
			default: false
		},
		dismissible: {
			default: false
		}
	}
}
</script>
